import { memo } from "react";
import type { BatchJobPanelProps } from "../../batch_job_kind_contract";
import { CoverageGapRecheckPanelBody } from "./CoverageGapRecheckPanelBody";
import { useCoverageGapRecheckPanel } from "./useCoverageGapRecheckPanel";

/** Results panel for a coverage_gap_recheck batch job. */
export const CoverageGapRecheckPanel = memo(function CoverageGapRecheckPanel({
  job,
}: BatchJobPanelProps) {
  const panel = useCoverageGapRecheckPanel(job);
  return <CoverageGapRecheckPanelBody panel={panel} />;
});
